var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('h3',{staticClass:"subheading"},[_vm._v("Last 10 days")]),(!_vm.load)?_c('inline-loader'):_c('vue-bar-graph',{attrs:{"points":_vm.get10DayArray('pageviews', 'date'),"show-y-axis":true,"show-x-axis":true,"width":_vm.getElementWidth(),"height":300,"show-values":true,"barColor":'#67247c'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }